import { render, staticRenderFns } from "./RestoreCourse.vue?vue&type=template&id=7365ec04&"
import script from "./RestoreCourse.vue?vue&type=script&lang=js&"
export * from "./RestoreCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports